import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import hrtf0 from "./components/hrtf-0";
import hrtf45 from "./components/hrtf-45";

const principle: Slide = {
  description:
    "In the examples below, you can listen to the same sound sample convolved with the frontal Head Realted Transfer Functions (HRTFs) measured for four different individuals and two different source positions. Notice how individual anatomical features lead to different HRTFs.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "HRTF (0°, 0°)" }, { name: "HRTF (45°, 0°)" }],
        },
      ],
      extraContent: [[], []],
      components: [hrtf0, hrtf45],
    },
    styles: {
      padding: "3% 0 0 0",
    },
  },
};

export default principle;
